import { connect } from 'react-redux';
import CreateSchemaSpecForm from './CreateSchemaSpecForm';
import { FORM_TYPE_CREATE_SCHEMA_SPEC } from '../../constants/formTypes';
import { GET_TRANSFORMED_SAMPLES_REQUEST } from '../../constants/actionTypes';
import {
  updateFormData,
  resetFormData,
  setFormError,
  setFormStageIndex,
  testSchemaSpec,
  createSchemaSpecFromForm,
  updateSchemaSpecFromForm,
  setContextualSupport,
  unsetContextualSupport,
} from '../../actions';
import JSONUtils from '../../lib/JSONUtils';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

const initializeFormData = (isEditMode = false, specBeingEdited = null) => {
  let name = null,
    description = null;

  let input = '';
  // let inputAttrs = ['ID', 'NAME'];
  let outputSchema = {
    data_samples: [],
    schema: {},
    flatSchema: [],
    flatSamples: [],
  };
  let specUpdateDone = false;
  let specUpdateId = null;
  let specUpdateError = null;

  if (isEditMode === true && !isNil(specBeingEdited)) {
    name = specBeingEdited.name;
    description = specBeingEdited.description;
    input = JSONUtils.stringifyJson(specBeingEdited.data_samples);
    outputSchema = {
      schema: specBeingEdited.schema,
      data_samples: specBeingEdited.data_samples,
      flatSchema: specBeingEdited.flatSchema,
      flatSamples: specBeingEdited.flatSamples,
    };
  }

  return {
    name,
    description,
    input,
    outputSchema,
    shouldInitFormData: true,
    specUpdateDone,
    specUpdateId,
    specUpdateError,
  };
};

const mapStateToProps = (state, ownProps) => {
  const { forms, request } = state;

  let form = forms[FORM_TYPE_CREATE_SCHEMA_SPEC];
  let currentStage = form ? form.currentStage : 0;
  let formData = form ? form.data : null;
  let isFormAwaitingValidation = form ? form.awaitingValidation : false;
  if (isEmpty(formData)) {
    formData = initializeFormData(ownProps.isEditMode, ownProps.specBeingEdited);
  }
  let isFetchingOutputSamples = !!request[GET_TRANSFORMED_SAMPLES_REQUEST];

  return {
    currentStage,
    isFormAwaitingValidation,
    formData,
    isFetchingOutputSamples,
  };
};

export default connect(mapStateToProps, {
  updateFormData,
  resetFormData,
  setFormError,
  setFormStageIndex,
  testSchemaSpec,
  createSchemaSpecFromForm,
  updateSchemaSpecFromForm,
  setContextualSupport,
  unsetContextualSupport,
})(CreateSchemaSpecForm);
